// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-class[data-v-0a415cca] {\n  height: 650px;\n  overflow: auto;\n  line-height: 30px;\n  padding: 0 30px;\n}\n.dialog-class p[data-v-0a415cca] {\n  line-height: 30px;\n  margin: 0;\n}", ""]);
// Exports
module.exports = exports;
